import TakeControl from './TakeControl';

export default TakeControl;
